module.exports = __webpack_public_path__ + "static/img/tryout_bc_02_zh.9d2684b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout_bc_02_zh.png
// module id = Jf4Z
// module chunks = 34